import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-journal-post-newsletter',
  templateUrl: './journal-post-newsletter.component.html',
  styleUrls: ['./journal-post-newsletter.component.scss']
})
export class JournalPostNewsletterComponent implements OnInit {
  @Input() header;

  constructor() { }

  ngOnInit() {
  }

}
